const translations = {
  "en": {
    "What is %{var0} (%{var1})?": "What is %{var0} (%{var1})?",
    "What is %{var0}?": "What is %{var0}?"
  },
  "zh-tw": {
    "What is %{var0} (%{var1})?": "%{var0}（%{var1}）是什麼？",
    "What is %{var0}?": "什麼是 %{var0}？"
  }
};

export default translations;
